import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { topCategories } from "data/topCategories";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import Link from "next/link";

const CategoriesSection = () => {

  // FAST AOS INIT
  useEffect(() => {
    AOS.init({
      duration: 400, // was 1000
      once: true,
      offset: 100,
      easing: "ease-out-cubic",
    });
  }, []);

  const handleRedirect = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section
      className="layout-pt-md layout-pb-md flex flex-col items-center"
      data-aos="fade-up"
    >
      <div className="container flex flex-col items-center">

        {/* TITLE */}
        <div className="row justify-center text-center w-full">
          <div
            className="col-auto"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            <div className="sectionTitle">
              <h2 className="sectionTitle__title">
                Top Medical{" "}
                <span className="predict-highlight">Colleges</span>
              </h2>
              <p
                className="sectionTitle__text"
                style={{ fontSize: "15px" }}
              >
                Top MBBS Colleges in India for NEET Aspirants
              </p>
            </div>
          </div>
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 pt-10 w-full">
          {topCategories.map((elm, i) => (
            <div
              key={elm.id}
              className="col-xl-3 col-lg-4 col-md-6 linkCustomTwo"
              data-aos="fade-up"
              data-aos-delay={i * 80} // was 150
              onClick={() => handleRedirect(elm.url)}
            >
              <div
                className="categoryCard -type-3 border-category"
                style={{
                  borderColor: "#ff9245",
                  borderRadius: "8px",
                  padding: "20px",
                  minHeight: "120px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s",
                }}
              >
                <div
                  className="categoryCard__icon no-background mr-4"
                  data-aos="zoom-in"
                  data-aos-delay={i * 90} // was 120
                >
                  <img
                    src={elm.iconSrc}
                    alt={elm.title}
                    width="50"
                    height="50"
                    loading="lazy"
                    style={{ objectFit: "contain" }}
                  />
                </div>

                <div className="categoryCard__content">
                  <h3
                    className="font-medium text-gray-800"
                    data-aos="fade-right"
                    data-aos-delay={i * 100} // was 150
                    style={{
                      fontSize: "15px",
                      color: "#333",
                      marginBottom: "5px",
                    }}
                  >
                    {elm.title}
                  </h3>

                  <div
                    className="lh-1 mt-50"
                    data-aos="fade-left"
                    data-aos-delay={i * 120} // was 200
                    style={{
                      fontSize: "13px",
                      color: "#666",
                    }}
                  >
                    {elm.courses}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* BUTTON */}
        <div className="row justify-center pt-5 lg:pt-[40px]">
          <div className="col-auto" data-aos="fade-up" data-aos-delay="180">
            <Link
              href="/collegeList"
              className="button -icon -orange-1 text-white"
              style={{
                display: "inline-block",
                backgroundColor: "rgb(255,146,69)",
                color: "#fff",
                borderRadius: "25px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "16px",
                padding: "12px 24px",
              }}>
              View All
                              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className="ml-2 text-sm"
              />

            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CategoriesSection;
